import PinLight2Icon from '../../../../../../../assets/svgs/PinLight2'

import { formatSalary, joinParts, safeUrl } from '../../../../format'

import style from './style.module.css'

const PositionItem = ({ position }) => {
  const href = safeUrl(position.url)

  const meta = joinParts([
    position.seniority,
    position.jobType,
    position.isRemote ? 'Remote' : null,
    formatSalary(position.salaryMin, position.salaryMax, position.currency),
  ])

  const body = (
    <>
      {position.title && (
        <span className={style.companyModal_position_item_title}>{position.title}</span>
      )}

      {position.location && (
        <span className={style.companyModal_position_location}>
          <PinLight2Icon />
          <span>{position.location}</span>
        </span>
      )}

      {meta && <span className={style.companyModal_position_meta}>{meta}</span>}
    </>
  )

  if (!href) {
    return <div className={style.companyModal_position_item}>{body}</div>
  }

  return (
    <a
      className={`${style.companyModal_position_item} ${style.companyModal_position_item_link}`}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-log-action="spotlight_open_position"
    >
      {body}
    </a>
  )
}

export default PositionItem
